import { isDev } from "@helpers/utils";
import { useEffect } from "react";

const useDevMode = () => {
  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (isDev()) {
      timeout = setTimeout(() => {
        document.getElementById("tidio-chat")?.remove();
      }, 1000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, []);
};

export default useDevMode;
